document.addEventListener('DOMContentLoaded', function () {
  var spinners = document.querySelectorAll('.loading-overlay__spinner');
  spinners.forEach(function (spinner) {
    var button = spinner.closest('button');
    if (!button) return;
    var wasLoading = false;
    var observer = new MutationObserver(function () {
      var isLoading = !spinner.classList.contains('hidden');
      if (isLoading) {
        wasLoading = true;
      } else if (wasLoading) {
        wasLoading = false;
        button.classList.add('is-added');
        setTimeout(function () {
          button.classList.remove('is-added');
        }, 900);
      }
    });
    observer.observe(spinner, { attributes: true, attributeFilter: ['class'] });
  });
});
